import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.8, delay, ease: EASE }}
    >
        {children}
    </motion.div>
);

export const SectionHead = ({ eyebrow, title, text, dark = false, testId }) => (
    <div className="max-w-2xl">
        <Reveal>
            <p
                className={`flex items-center gap-3 text-xs font-bold uppercase tracking-[0.28em] ${
                    dark ? "text-gold" : "text-gold-dark"
                }`}
            >
                <span className={`h-px w-8 ${dark ? "bg-gold" : "bg-gold-dark"}`} />
                {eyebrow}
            </p>
        </Reveal>
        <Reveal delay={0.08}>
            <h2
                data-testid={testId}
                className={`mt-4 font-display text-3xl font-semibold leading-[1.08] tracking-tight sm:text-4xl lg:text-[2.75rem] ${
                    dark ? "text-white" : "text-slate-900"
                }`}
            >
                {title}
            </h2>
        </Reveal>
        {text ? (
            <Reveal delay={0.16}>
                <p className={`mt-5 text-base leading-relaxed ${dark ? "text-slate-300" : "text-slate-600"}`}>
                    {text}
                </p>
            </Reveal>
        ) : null}
    </div>
);
